
import { smilieProxyUrl } from '@/lib/smilie-proxy-url';

const FLOATS = [
  { code: 'nameglow', top: '14%', left: '12%', size: 38, delay: 0.2, duration: 6.2, opacity: 0.22 },
  { code: 'purple', top: '18%', left: '88%', size: 42, delay: 0.8, duration: 5.8, opacity: 0.2, rev: true },
  { code: 'stella', top: '72%', left: '10%', size: 36, delay: 1.1, duration: 6.4, opacity: 0.18 },
  { code: 'cstyle', top: '78%', left: '86%', size: 40, delay: 0.5, duration: 5.6, opacity: 0.2, rev: true },
  { code: 'everypower', top: '42%', left: '6%', size: 34, delay: 1.4, duration: 6.8, opacity: 0.16, rev: true },
  { code: 'pink', top: '52%', left: '92%', size: 32, delay: 0.3, duration: 5.9, opacity: 0.17 },
] as const;

type FloatItem = (typeof FLOATS)[number];

function powerImageSrc(code: string): string {
  return smilieProxyUrl(code, 40);
}

export default function AdminLoginFloatingSmilies() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      {FLOATS.map((s: FloatItem, idx) => (
        <div
          key={idx}
          className="absolute"
          style={{
            top: s.top,
            left: s.left,
            transform: 'translate(-50%, -50%)',
            opacity: s.opacity,
          }}
        >
          <div
            className={'rev' in s && s.rev ? 'animate-hero-smiley-float-rev' : 'animate-hero-smiley-float'}
            style={{
              width: s.size,
              animationDelay: `${s.delay}s`,
              animationDuration: `${s.duration}s`,
            }}
          >
            <img
              src={powerImageSrc(s.code)}
              alt=""
              width={s.size}
              height={s.size}
              className="h-auto w-full select-none object-contain drop-shadow-[0_2px_12px_rgba(0,0,0,0.35)]"
              loading="lazy"
              draggable={false}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
